import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from 'react-router-dom';
import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import { getLevels, editImpact, editProbability } from "../store/actions/riskActions";
import ContentEditable from 'react-contenteditable';

function RiskLevels(props) {
    const { token, levels, getLevelsFN, editImpactFN, editProbabilityFN } = props;

    const colorsProbabilities = [
        { value: 'Rare', label: 'Rare', color: "#0081A7" },
        { value: 'Unlikely', label: 'Unlikely', color: "#00AFB9" },
        { value: 'Possible', label: 'Possible', color: "#FED9B7" },
        { value: 'Likely', label: 'Likely', color: "#F07167" },
        { value: 'Almost certain', label: 'Almost Certain', color: "#b4170b" }
    ];

    const colorsImpacts = [
        { value: 'Insignificant', label: 'Insignificant', color: "#0081A7" },
        { value: 'Minor', label: 'Minor', color: "#00AFB9" },
        { value: 'Moderate', label: 'Moderate', color: "#FED9B7" },
        { value: 'Major', label: 'Major', color: "#F07167" },
        { value: 'Catastrophe', label: 'Catastrophe', color: "#b4170b" }
    ];

    const editableProbability = useRef([]);
    const editableImpact = useRef([]);

    useEffect(() => {
        getLevelsFN();
    }, [getLevelsFN]);

    useEffect(() => {
        if (levels) {
            editableProbability.current = levels.riskProbabilities?.map(probability => ({
                controls: probability.controls,
                frequency: probability.frequency,
            })) || [];
            editableImpact.current = levels.riskImpacts?.map(impact => ({ ...impact })) || [];
        }
    }, [levels]);

    const handleInputChange = (value) => {
        const parsedValue = parseInt(value, 10);
        return isNaN(parsedValue) ? '' : parsedValue;
    };

    return token ? (
       
          
           
               
                <div className="flex flex-col w-full p-4 overflow-auto">
                    <div className="h-full w-full mt-4">

                        <h1 className="text-xl font-bold mb-4 text-[#3b3b3b]">Risk Probability</h1>

                        {levels?.riskProbabilities?.length > 0 && (
                            <div className="table w-full mb-6 border border-gray-300 rounded-lg bg-[#EEF0ED]">
                                <div className="table-row bg-[#EEF0ED]">
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Scale</div>
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Controls</div>
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Frequency</div>
                                </div>
                                {levels.riskProbabilities.map((probability, index) => (
                                    <div key={index} className="table-row bg-white text-[#3b3b3b] text-normal">
                                        <div className="table-cell p-4 border-b border-gray-300">
                                            <div style={{
                                                display: 'inline-block',
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: colorsProbabilities.find(color => color.value === probability.scale)?.color || 'transparent',
                                                borderRadius: '50%',
                                                marginRight: '5px'
                                            }} />
                                            <span>{probability.scale}</span>
                                        </div>
                                        <div className="table-cell p-4 border-b border-gray-300">
                                            <ContentEditable
                                                html={editableProbability.current[index]?.controls}
                                                disabled={false}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    editableProbability.current[index].controls = e.target.value;
                                                }}
                                                onBlur={() => {
                                                    editProbabilityFN(probability.id, editableProbability.current[index].controls, editableProbability.current[index].frequency);
                                                }}
                                                tagName="span"
                                            />
                                        </div>
                                        <div className="table-cell p-4 border-b border-gray-300">
                                            <ContentEditable
                                                html={editableProbability.current[index]?.frequency}
                                                disabled={false}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    editableProbability.current[index].frequency = e.target.value;
                                                }}
                                                onBlur={() => {
                                                    editProbabilityFN(probability.id, editableProbability.current[index].controls, editableProbability.current[index].frequency);
                                                }}
                                                tagName="span"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        <h1 className="text-xl font-bold mb-4 text-[#3b3b3b]">Risk Impacts</h1>

                        {levels?.riskImpacts?.length > 0 && (
                            <div className="table w-full mb-6 border border-gray-300 rounded-lg bg-[#EEF0ED]">
                                <div className="table-row bg-[#EEF0ED]">
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Impact</div>
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Operational</div>
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Financial</div>
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Reputational</div>
                                    <div className="table-cell p-4 border-b border-gray-300 font-semibold">Strategic</div>
                                </div>
                                {levels.riskImpacts.map((impact, index) => (
                                    <div key={index} className="table-row bg-white text-[#3b3b3b] text-normal">
                                        <div className="table-cell p-4 border-b border-gray-300">
                                            <div style={{
                                                display: 'inline-block',
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: colorsImpacts.find(color => color.value === impact.impact)?.color || 'transparent',
                                                borderRadius: '50%',
                                                marginRight: '5px'
                                            }} />
                                            <span>{impact.impact}</span>
                                        </div>
                                        <div className="table-cell p-4 border-b border-gray-300">
                                            <ContentEditable
                                                html={editableImpact.current[index]?.operational}
                                                disabled={false}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    editableImpact.current[index].operational = e.target.value;
                                                }}
                                                onBlur={() => {
                                                    editImpactFN(
                                                        impact.id,
                                                        editableImpact.current[index].operational,
                                                        editableImpact.current[index].financial_low,
                                                        editableImpact.current[index].financial_high,
                                                        editableImpact.current[index].reputational,
                                                        editableImpact.current[index].strategic
                                                    );
                                                }}
                                                tagName="span"
                                            />
                                        </div>
                                        <div className="table-cell p-4 border-b border-gray-300 flex gap-2 items-center">
                                            {impact.impact === 'Catastrophe' ? (
                                                <>
                                                    <span>{'>  $'}</span>
                                                    <ContentEditable
                                                        html={String(editableImpact.current[index]?.financial_low || '')}
                                                        disabled={false}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                e.target.blur();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            editableImpact.current[index].financial_low = handleInputChange(e.target.value);
                                                        }}
                                                        onBlur={() => {
                                                            editImpactFN(
                                                                impact.id,
                                                                editableImpact.current[index].operational,
                                                                editableImpact.current[index].financial_low,
                                                                editableImpact.current[index].financial_high,
                                                                editableImpact.current[index].reputational,
                                                                editableImpact.current[index].strategic
                                                            );
                                                        }}
                                                        tagName="span"
                                                    />
                                                </>
                                            ) : impact.impact === 'Insignificant' ? (
                                                <>
                                                    <span>{'<  $'}</span>
                                                    <ContentEditable
                                                        html={String(editableImpact.current[index]?.financial_high || '')}
                                                        disabled={false}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                e.target.blur();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            editableImpact.current[index].financial_high = handleInputChange(e.target.value);
                                                        }}
                                                        onBlur={() => {
                                                            editImpactFN(
                                                                impact.id,
                                                                editableImpact.current[index].operational,
                                                                editableImpact.current[index].financial_low,
                                                                editableImpact.current[index].financial_high,
                                                                editableImpact.current[index].reputational,
                                                                editableImpact.current[index].strategic
                                                            );
                                                        }}
                                                        tagName="span"
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <span>$</span>
                                                    <ContentEditable
                                                        html={String(editableImpact.current[index]?.financial_low || '')}
                                                        disabled={false}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                e.target.blur();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            editableImpact.current[index].financial_low = handleInputChange(e.target.value);
                                                        }}
                                                        onBlur={() => {
                                                            editImpactFN(
                                                                impact.id,
                                                                editableImpact.current[index].operational,
                                                                editableImpact.current[index].financial_low,
                                                                editableImpact.current[index].financial_high,
                                                                editableImpact.current[index].reputational,
                                                                editableImpact.current[index].strategic
                                                            );
                                                        }}
                                                        tagName="span"
                                                    />
                                                    <span>-   </span>
                                                    <span>$</span>
                                                    <ContentEditable
                                                        html={String(editableImpact.current[index]?.financial_high || '')}
                                                        disabled={false}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                e.target.blur();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            editableImpact.current[index].financial_high = handleInputChange(e.target.value);
                                                        }}
                                                        onBlur={() => {
                                                            editImpactFN(
                                                                impact.id,
                                                                editableImpact.current[index].operational,
                                                                editableImpact.current[index].financial_low,
                                                                editableImpact.current[index].financial_high,
                                                                editableImpact.current[index].reputational,
                                                                editableImpact.current[index].strategic
                                                            );
                                                        }}
                                                        tagName="span"
                                                    />
                                                </>
                                            )}
                                        </div>
                                        <div className="table-cell p-4 border-b border-gray-300">
                                            <ContentEditable
                                                html={editableImpact.current[index]?.reputational}
                                                disabled={false}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    editableImpact.current[index].reputational = e.target.value;
                                                }}
                                                onBlur={() => {
                                                    editImpactFN(
                                                        impact.id,
                                                        editableImpact.current[index].operational,
                                                        editableImpact.current[index].financial_low,
                                                        editableImpact.current[index].financial_high,
                                                        editableImpact.current[index].reputational,
                                                        editableImpact.current[index].strategic
                                                    );
                                                }}
                                                tagName="span"
                                            />
                                        </div>
                                        <div className="table-cell p-4 border-b border-gray-300">
                                            <ContentEditable
                                                html={editableImpact.current[index]?.strategic}
                                                disabled={false}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    editableImpact.current[index].strategic = e.target.value;
                                                }}
                                                onBlur={() => {
                                                    editImpactFN(
                                                        impact.id,
                                                        editableImpact.current[index].operational,
                                                        editableImpact.current[index].financial_low,
                                                        editableImpact.current[index].financial_high,
                                                        editableImpact.current[index].reputational,
                                                        editableImpact.current[index].strategic
                                                    );
                                                }}
                                                tagName="span"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
          
    ) : <Redirect to="/login" />;
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
    levels: state.risk.levels,
});

const mapDispatchToProps = (dispatch) => ({
    getLevelsFN: () => dispatch(getLevels()),
    editImpactFN: (impact_id, operational, financial_low, financial_high, reputational, strategic) =>
        dispatch(editImpact(impact_id, operational, financial_low, financial_high, reputational, strategic)),
    editProbabilityFN: (probability_id, controls, frequency) =>
        dispatch(editProbability(probability_id, controls, frequency)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(RiskLevels);



// return token ? (
//         <div className="flex flex-col w-full h-screen overflow-hidden">
//             <TopBar className="fixed top-0 left-0 right-0 z-10" />
//             <div className="flex flex-row w-full h-full overflow-hidden">
//                 <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" />
//                 <div className="flex flex-col w-full p-4 overflow-auto">
//                     <div className="h-full w-full mt-4">

//                         <h1 className="text-xl font-bold mb-4 text-[#3b3b3b]">Risk Probability</h1>

//                         {levels?.riskProbabilities?.length > 0 && (
//                             <div className="table w-full mb-6 border border-gray-300 rounded-lg bg-[#EEF0ED]">
//                                 <div className="table-row bg-[#EEF0ED]">
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Scale</div>
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Controls</div>
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Frequency</div>
//                                 </div>
//                                 {levels.riskProbabilities.map((probability, index) => (
//                                     <div key={index} className="table-row bg-white text-[#3b3b3b] text-normal">
//                                         <div className="table-cell p-4 border-b border-gray-300">
//                                             <div style={{
//                                                 display: 'inline-block',
//                                                 width: '10px',
//                                                 height: '10px',
//                                                 backgroundColor: colorsProbabilities.find(color => color.value === probability.scale)?.color || 'transparent',
//                                                 borderRadius: '50%',
//                                                 marginRight: '5px'
//                                             }} />
//                                             <span>{probability.scale}</span>
//                                         </div>
//                                         <div className="table-cell p-4 border-b border-gray-300">
//                                             <ContentEditable
//                                                 html={editableProbability.current[index]?.controls}
//                                                 disabled={false}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter') {
//                                                         e.preventDefault();
//                                                         e.target.blur();
//                                                     }
//                                                 }}
//                                                 onChange={(e) => {
//                                                     editableProbability.current[index].controls = e.target.value;
//                                                 }}
//                                                 onBlur={() => {
//                                                     editProbabilityFN(probability.id, editableProbability.current[index].controls, editableProbability.current[index].frequency);
//                                                 }}
//                                                 tagName="span"
//                                             />
//                                         </div>
//                                         <div className="table-cell p-4 border-b border-gray-300">
//                                             <ContentEditable
//                                                 html={editableProbability.current[index]?.frequency}
//                                                 disabled={false}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter') {
//                                                         e.preventDefault();
//                                                         e.target.blur();
//                                                     }
//                                                 }}
//                                                 onChange={(e) => {
//                                                     editableProbability.current[index].frequency = e.target.value;
//                                                 }}
//                                                 onBlur={() => {
//                                                     editProbabilityFN(probability.id, editableProbability.current[index].controls, editableProbability.current[index].frequency);
//                                                 }}
//                                                 tagName="span"
//                                             />
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}

//                         <h1 className="text-xl font-bold mb-4 text-[#3b3b3b]">Risk Impacts</h1>

//                         {levels?.riskImpacts?.length > 0 && (
//                             <div className="table w-full mb-6 border border-gray-300 rounded-lg bg-[#EEF0ED]">
//                                 <div className="table-row bg-[#EEF0ED]">
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Impact</div>
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Operational</div>
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Financial</div>
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Reputational</div>
//                                     <div className="table-cell p-4 border-b border-gray-300 font-semibold">Strategic</div>
//                                 </div>
//                                 {levels.riskImpacts.map((impact, index) => (
//                                     <div key={index} className="table-row bg-white text-[#3b3b3b] text-normal">
//                                         <div className="table-cell p-4 border-b border-gray-300">
//                                             <div style={{
//                                                 display: 'inline-block',
//                                                 width: '10px',
//                                                 height: '10px',
//                                                 backgroundColor: colorsImpacts.find(color => color.value === impact.impact)?.color || 'transparent',
//                                                 borderRadius: '50%',
//                                                 marginRight: '5px'
//                                             }} />
//                                             <span>{impact.impact}</span>
//                                         </div>
//                                         <div className="table-cell p-4 border-b border-gray-300">
//                                             <ContentEditable
//                                                 html={editableImpact.current[index]?.operational}
//                                                 disabled={false}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter') {
//                                                         e.preventDefault();
//                                                         e.target.blur();
//                                                     }
//                                                 }}
//                                                 onChange={(e) => {
//                                                     editableImpact.current[index].operational = e.target.value;
//                                                 }}
//                                                 onBlur={() => {
//                                                     editImpactFN(
//                                                         impact.id,
//                                                         editableImpact.current[index].operational,
//                                                         editableImpact.current[index].financial_low,
//                                                         editableImpact.current[index].financial_high,
//                                                         editableImpact.current[index].reputational,
//                                                         editableImpact.current[index].strategic
//                                                     );
//                                                 }}
//                                                 tagName="span"
//                                             />
//                                         </div>
//                                         <div className="table-cell p-4 border-b border-gray-300 flex gap-2 items-center">
//                                             {impact.impact === 'Catastrophe' ? (
//                                                 <>
//                                                     <span>{'>  $'}</span>
//                                                     <ContentEditable
//                                                         html={String(editableImpact.current[index]?.financial_low || '')}
//                                                         disabled={false}
//                                                         onKeyDown={(e) => {
//                                                             if (e.key === 'Enter') {
//                                                                 e.preventDefault();
//                                                                 e.target.blur();
//                                                             }
//                                                         }}
//                                                         onChange={(e) => {
//                                                             editableImpact.current[index].financial_low = handleInputChange(e.target.value);
//                                                         }}
//                                                         onBlur={() => {
//                                                             editImpactFN(
//                                                                 impact.id,
//                                                                 editableImpact.current[index].operational,
//                                                                 editableImpact.current[index].financial_low,
//                                                                 editableImpact.current[index].financial_high,
//                                                                 editableImpact.current[index].reputational,
//                                                                 editableImpact.current[index].strategic
//                                                             );
//                                                         }}
//                                                         tagName="span"
//                                                     />
//                                                 </>
//                                             ) : impact.impact === 'Insignificant' ? (
//                                                 <>
//                                                     <span>{'<  $'}</span>
//                                                     <ContentEditable
//                                                         html={String(editableImpact.current[index]?.financial_high || '')}
//                                                         disabled={false}
//                                                         onKeyDown={(e) => {
//                                                             if (e.key === 'Enter') {
//                                                                 e.preventDefault();
//                                                                 e.target.blur();
//                                                             }
//                                                         }}
//                                                         onChange={(e) => {
//                                                             editableImpact.current[index].financial_high = handleInputChange(e.target.value);
//                                                         }}
//                                                         onBlur={() => {
//                                                             editImpactFN(
//                                                                 impact.id,
//                                                                 editableImpact.current[index].operational,
//                                                                 editableImpact.current[index].financial_low,
//                                                                 editableImpact.current[index].financial_high,
//                                                                 editableImpact.current[index].reputational,
//                                                                 editableImpact.current[index].strategic
//                                                             );
//                                                         }}
//                                                         tagName="span"
//                                                     />
//                                                 </>
//                                             ) : (
//                                                 <>
//                                                     <span>$</span>
//                                                     <ContentEditable
//                                                         html={String(editableImpact.current[index]?.financial_low || '')}
//                                                         disabled={false}
//                                                         onKeyDown={(e) => {
//                                                             if (e.key === 'Enter') {
//                                                                 e.preventDefault();
//                                                                 e.target.blur();
//                                                             }
//                                                         }}
//                                                         onChange={(e) => {
//                                                             editableImpact.current[index].financial_low = handleInputChange(e.target.value);
//                                                         }}
//                                                         onBlur={() => {
//                                                             editImpactFN(
//                                                                 impact.id,
//                                                                 editableImpact.current[index].operational,
//                                                                 editableImpact.current[index].financial_low,
//                                                                 editableImpact.current[index].financial_high,
//                                                                 editableImpact.current[index].reputational,
//                                                                 editableImpact.current[index].strategic
//                                                             );
//                                                         }}
//                                                         tagName="span"
//                                                     />
//                                                     <span>-   </span>
//                                                     <span>$</span>
//                                                     <ContentEditable
//                                                         html={String(editableImpact.current[index]?.financial_high || '')}
//                                                         disabled={false}
//                                                         onKeyDown={(e) => {
//                                                             if (e.key === 'Enter') {
//                                                                 e.preventDefault();
//                                                                 e.target.blur();
//                                                             }
//                                                         }}
//                                                         onChange={(e) => {
//                                                             editableImpact.current[index].financial_high = handleInputChange(e.target.value);
//                                                         }}
//                                                         onBlur={() => {
//                                                             editImpactFN(
//                                                                 impact.id,
//                                                                 editableImpact.current[index].operational,
//                                                                 editableImpact.current[index].financial_low,
//                                                                 editableImpact.current[index].financial_high,
//                                                                 editableImpact.current[index].reputational,
//                                                                 editableImpact.current[index].strategic
//                                                             );
//                                                         }}
//                                                         tagName="span"
//                                                     />
//                                                 </>
//                                             )}
//                                         </div>
//                                         <div className="table-cell p-4 border-b border-gray-300">
//                                             <ContentEditable
//                                                 html={editableImpact.current[index]?.reputational}
//                                                 disabled={false}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter') {
//                                                         e.preventDefault();
//                                                         e.target.blur();
//                                                     }
//                                                 }}
//                                                 onChange={(e) => {
//                                                     editableImpact.current[index].reputational = e.target.value;
//                                                 }}
//                                                 onBlur={() => {
//                                                     editImpactFN(
//                                                         impact.id,
//                                                         editableImpact.current[index].operational,
//                                                         editableImpact.current[index].financial_low,
//                                                         editableImpact.current[index].financial_high,
//                                                         editableImpact.current[index].reputational,
//                                                         editableImpact.current[index].strategic
//                                                     );
//                                                 }}
//                                                 tagName="span"
//                                             />
//                                         </div>
//                                         <div className="table-cell p-4 border-b border-gray-300">
//                                             <ContentEditable
//                                                 html={editableImpact.current[index]?.strategic}
//                                                 disabled={false}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter') {
//                                                         e.preventDefault();
//                                                         e.target.blur();
//                                                     }
//                                                 }}
//                                                 onChange={(e) => {
//                                                     editableImpact.current[index].strategic = e.target.value;
//                                                 }}
//                                                 onBlur={() => {
//                                                     editImpactFN(
//                                                         impact.id,
//                                                         editableImpact.current[index].operational,
//                                                         editableImpact.current[index].financial_low,
//                                                         editableImpact.current[index].financial_high,
//                                                         editableImpact.current[index].reputational,
//                                                         editableImpact.current[index].strategic
//                                                     );
//                                                 }}
//                                                 tagName="span"
//                                             />
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     ) : <Redirect to="/login" />;